// material-ui
import { Card, CardContent, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

// ==============================|| SKELETON - EARNING CARD ||============================== //
const UpdatePlanCardSkeleton = () => (
    <>
        <Grid item>
            <Card className="upgrade-plan-wrapper">
                <CardContent>
                    <Skeleton variant="rectangular" height={380} width={1100} />
                </CardContent>
            </Card>
        </Grid>
        <Grid item>
            <Card className="upgrade-plan-wrapper">
                <CardContent>
                    <Skeleton variant="rectangular" height={380} width={1100} />
                </CardContent>
            </Card>
        </Grid>
    </>
);

export default UpdatePlanCardSkeleton;
